export { default as Toast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export const toastOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 5,
  newestOnTop: true,
}
